module.exports = window.__loadMfRemote("refundly", "refundlyUrl");